// import React, { useState, createContext } from "react";

const DietData3 = [    
    {
        title: "Plan Optimal",
        shortTitle: "Optimal",
        testExtraPay: 0.0,
        mealCount: 3,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 43
                    },
                    {
                        dayCount: 14,
                        price: 42
                    },
                    {
                        dayCount: 21,
                        price: 41
                    },
                    {
                        dayCount: 28,
                        price: 40
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 44
                    },
                    {
                        dayCount: 14,
                        price: 43
                    },
                    {
                        dayCount: 21,
                        price: 42
                    },
                    {
                        dayCount: 28,
                        price: 41
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 45
                    },
                    {
                        dayCount: 14,
                        price: 44
                    },
                    {
                        dayCount: 21,
                        price: 43
                    },
                    {
                        dayCount: 28,
                        price: 42
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 46
                    },
                    {
                        dayCount: 14,
                        price: 45
                    },
                    {
                        dayCount: 21,
                        price: 44
                    },
                    {
                        dayCount: 28,
                        price: 43
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 1,
                        price: 47
                    },
                    {
                        dayCount: 14,
                        price: 46
                    },
                    {
                        dayCount: 21,
                        price: 45
                    },
                    {
                        dayCount: 28,
                        price: 44
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 1,
                        price: 48
                    },
                    {
                        dayCount: 14,
                        price: 47
                    },
                    {
                        dayCount: 21,
                        price: 46
                    },
                    {
                        dayCount: 28,
                        price: 45
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 50
                    },
                    {
                        dayCount: 14,
                        price: 49
                    },
                    {
                        dayCount: 21,
                        price: 48
                    },
                    {
                        dayCount: 28,
                        price: 47
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 53
                    },
                    {
                        dayCount: 14,
                        price: 52
                    },
                    {
                        dayCount: 21,
                        price: 51
                    },
                    {
                        dayCount: 28,
                        price: 50
                    },
                ]
            }
        ],
    },

    {
        title: "Plan Wege",
        shortTitle: "Wege",
        testExtraPay: 0.0,
        mealCount: 3,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 43
                    },
                    {
                        dayCount: 14,
                        price: 42
                    },
                    {
                        dayCount: 21,
                        price: 41
                    },
                    {
                        dayCount: 28,
                        price: 40
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 44
                    },
                    {
                        dayCount: 14,
                        price: 43
                    },
                    {
                        dayCount: 21,
                        price: 42
                    },
                    {
                        dayCount: 28,
                        price: 41
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 45
                    },
                    {
                        dayCount: 14,
                        price: 44
                    },
                    {
                        dayCount: 21,
                        price: 43
                    },
                    {
                        dayCount: 28,
                        price: 42
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 46
                    },
                    {
                        dayCount: 14,
                        price: 45
                    },
                    {
                        dayCount: 21,
                        price: 44
                    },
                    {
                        dayCount: 28,
                        price: 43
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 1,
                        price: 47
                    },
                    {
                        dayCount: 14,
                        price: 46
                    },
                    {
                        dayCount: 21,
                        price: 45
                    },
                    {
                        dayCount: 28,
                        price: 44
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 1,
                        price: 48
                    },
                    {
                        dayCount: 14,
                        price: 47
                    },
                    {
                        dayCount: 21,
                        price: 46
                    },
                    {
                        dayCount: 28,
                        price: 45
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 50
                    },
                    {
                        dayCount: 14,
                        price: 49
                    },
                    {
                        dayCount: 21,
                        price: 48
                    },
                    {
                        dayCount: 28,
                        price: 47
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 53
                    },
                    {
                        dayCount: 14,
                        price: 52
                    },
                    {
                        dayCount: 21,
                        price: 51
                    },
                    {
                        dayCount: 28,
                        price: 50
                    },
                ]
            }
        ],
    },

    {
        title: "Plan IG",
        shortTitle: "IG",
        testExtraPay: 0.0,
        mealCount: 3,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 43
                    },
                    {
                        dayCount: 14,
                        price: 42
                    },
                    {
                        dayCount: 21,
                        price: 41
                    },
                    {
                        dayCount: 28,
                        price: 40
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 44
                    },
                    {
                        dayCount: 14,
                        price: 43
                    },
                    {
                        dayCount: 21,
                        price: 42
                    },
                    {
                        dayCount: 28,
                        price: 41
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 45
                    },
                    {
                        dayCount: 14,
                        price: 44
                    },
                    {
                        dayCount: 21,
                        price: 43
                    },
                    {
                        dayCount: 28,
                        price: 42
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 46
                    },
                    {
                        dayCount: 14,
                        price: 45
                    },
                    {
                        dayCount: 21,
                        price: 44
                    },
                    {
                        dayCount: 28,
                        price: 43
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 1,
                        price: 47
                    },
                    {
                        dayCount: 14,
                        price: 46
                    },
                    {
                        dayCount: 21,
                        price: 45
                    },
                    {
                        dayCount: 28,
                        price: 44
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 1,
                        price: 48
                    },
                    {
                        dayCount: 14,
                        price: 47
                    },
                    {
                        dayCount: 21,
                        price: 46
                    },
                    {
                        dayCount: 28,
                        price: 45
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 50
                    },
                    {
                        dayCount: 14,
                        price: 49
                    },
                    {
                        dayCount: 21,
                        price: 48
                    },
                    {
                        dayCount: 28,
                        price: 47
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 53
                    },
                    {
                        dayCount: 14,
                        price: 52
                    },
                    {
                        dayCount: 21,
                        price: 51
                    },
                    {
                        dayCount: 28,
                        price: 50
                    },
                ]
            }
        ],
    },
]

export default DietData3